<div class="view-wrapper">
    <dx-scroll-view class="view-wrapper-scroll" (onScroll)="scroll($event)">

        <div class="dx-card responsive-paddings">
            <dx-toolbar [class]="isContentScrolled ? 'header-toolbar-scrolled' : 'header-toolbar'"
                [class.scrolled]="isContentScrolled">
                <dxi-item location="before">
                    <div class="header-text">{{!isMerchantCreatedSuccessfully ? 'Register Merchant' : 'Account Under Review'}}</div>
                </dxi-item>
            </dx-toolbar>
            <div *ngIf="!isMerchantCreatedSuccessfully">
                <div class="container">
                    <app-register-merchant-form-container
                        (notifyMerchantCreated)="handleMerchantPost($event)"></app-register-merchant-form-container>
                </div>
            </div>
            
            <!-- <div class="content-block" *ngIf="isMerchantCreatedSuccessfully">
                <div class="dx-card responsive-paddings account-under-review">
                    <div class="description">Your account is currently under review. We'll get back to you shortly once
                        the account is verified and supported.</div>
                </div>
            </div> -->
            

        </div>
    </dx-scroll-view>
</div>